import React, { useState, useEffect } from   'react';
import { NavLink} from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { BotonEditar } from '../Utils/BotonEditar';
import { useAuth } from '../../Auth/AuthContext';
import { Card, CardBody, FormControlButton, CardBodyTableResponsive } from './../Utils/StyledComponents';

export default function Departamentos(){
    const [Cargando, setCargando] = useState(false);
    const { token } = useAuth();
    const [departamentos, setDepartamentos] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10); 
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    function editarDepartament(row){
        return <BotonEditar Editar={EditarDepartamento} row={row}/>
    }
    const columns = [
        {
            name: 'Acciones',
            cell: row => editarDepartament(row),
            ignoreRowClick: true,
            width: '7%'
        },
        { name: 'Id', selector: row => row.id, sortable: true, width:'10%' },
        { name: 'Departamento', selector: row => row.depDepartamento, sortable: true, width: '25%'},
        { name: 'Estado', selector: row => row.depActivo?'Activo':'Inactivo', sortable: true, width: '7%' }
        ];
    useEffect(() => {
        fetchData(currentPage, perPage);
    }, [currentPage, perPage]);
    const fetchData = async (page, rowsPerPage) => {
        const url = `/parametros/departamentos?page=${page}&limit=${rowsPerPage}`;
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDepartamentos(result.data);
        setTotalRows(result.meta.total);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchData(page, perPage);
      };
    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchData(page, newPerPage);
    };
    function EditarDepartamento (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('depDepartamento', row.depDepartamento);
        setValue('depActivo', row.depActivo);
    };
    const NuevoMunicipio = () =>  {
        setValue('id', 0);
        setValue('depDepartamento', '');
        setValue('depActivo', false);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardardepartamento';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar departamento', JSON.stringify(response.data));
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar departamento', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar departamento', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('depDepartamento', '');
        setValue('depActivo', false);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Departamentos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><NavLink to={'/'} >Inicio</NavLink></li>
                        <li className="breadcrumb-item"><NavLink to={'/parametros'} >Par&aacute;metros</NavLink></li>
                        <li className="breadcrumb-item active"> Departamento</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                      {Cargando && <div className="centered">
                        <div><progress value={null} /></div>
                      </div>}
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario departamento</h3>
                                
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    
                                    <input hidden {...register('id')}/>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group" >
                                                <label htmlFor='depDepartamento'>Departamento</label>
                                                <input
                                                    {...register('depDepartamento', { required: true })}
                                                    className="form-control" 
                                                    placeholder="Departamento"
                                                    id='depDepartamento'
                                                />
                                                {errors.depDepartamento && <p style={{color: 'red'}}>Digitar dato</p>}
                                            </div>  
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-3'>
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('depActivo')}
                                                    className="custom-control-input" id="SwitchEstado"/>
                                                <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <Card>
                        <CardBody>
                            <CardBodyTableResponsive>
                                <FormControlButton onClick={NuevoMunicipio}>Nuevo</FormControlButton>
                                    <DataTable
                                        title="Lista de departamentos"
                                        columns={columns}
                                        data={departamentos}
                                        progressPending={Cargando}
                                        pagination
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        paginationPerPage={perPage}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePageChange}
                                        noDataComponent="No hay datos para mostrar"
                                    /> 
                            </CardBodyTableResponsive>
                        </CardBody>
                    </Card>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}